import React from 'react';
import { Dispatch } from '@reduxjs/toolkit';

import { LeaveRequest } from '../../../../interfaces/employee/leave-request.interface';

import { RemoveLeaveRequestAction } from '../../../../actions/leave-request/leave-request.types';
import { LeaveRequestActions } from '../../../../actions/leave-request/leave-request.actions';

import { useAppDispatch, useRemoval } from '../../../../hooks';

import { Modal } from '../../../../components/modal/Modal';
import { ModalLayout } from '../../../../components/modal/ModalLayout';
import RemoveModal from '../../../../components/modal/remove/RemoveModal';

const RemoveLeaveRequestContainer = () => {
  const dispatch: Dispatch<RemoveLeaveRequestAction> = useAppDispatch();

  const { element, showModal, setShowModal } = useRemoval();

  const onClose = () => setShowModal(false);

  const handleConfirm = (onComplete: () => void) => {
    dispatch(
      LeaveRequestActions.removeLeaveRequest((element as LeaveRequest).id as number, () => {
        onComplete();
        onClose();
      })
    );
  };

  return (
    <>
      {showModal && (
        <Modal>
          <ModalLayout onClose={onClose} title="Remove Leave Request">
            <RemoveModal title="this leave request" onConfirm={handleConfirm} />
          </ModalLayout>
        </Modal>
      )}
    </>
  );
};

export default RemoveLeaveRequestContainer;
